import * as headers from "../operations/hide_headers";

export function hideHeaders(state){
	headers.hideHeaders(this,state);
}